<template>
	<div class="pageBox">
		<Header ref="Header" current='souye'></Header>
		<div class="pageBox_cen">
			<template v-for="(item,index) in list">
				<component :is="mapComponent[item.name]" :list='item' @goScroll='goScroll' :ref="item.name"/>
			</template>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	import mapComponent from "@/components/mapComponent.js";
	import {
		get_list
	} from "@/api/innovation.js"
	
	import {
		get_banner,
	} from "@/api/index.js"
	export default {
	  components:{
		  Header,
		  Footer,
	  },
	  data(){
	    return{
			mapComponent,
			list:[
				{
					name:'innovationBanner',
					value: '创新轮播图',
					list: [
						// {
						// 	img: require("@/assets/content/banner.png"),
						// 	name: '创新前沿',
						// 	cen: '不经艰难困苦 何来玉汝于成以科技自立为命题 以创新变革为目标我们正持续探索内镜前沿技术',
						// 	cenEn: 'Explore the Frontiers of endoscopy'
						// }, 
					]
				},
				{
					name:'innovationCen',
					value: '创新内容',
				}
			],
			navHidden: false, // 导航栏是否隐藏
			lastScrollTop: 0, // 上一次页面滚动的位置
			currentRoute:'',
	    }
	  },
	  mounted() {
	  	window.addEventListener('scroll', this.handleScroll);
	  	 this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
	  	this.$watch('$route', this.onRouteChange);
		var element;
		if(this.nowVibe=='pc'){
			element= document.documentElement
		}else{
			element = document.documentElement.scrollTop ? document.documentElement : document.body;
		}
	  	let scrollTop = element.scrollTop;
	  	if(scrollTop==0){
	  		if(!this.$refs.Header.navHead){
	  			this.$refs.Header.headerHover = false;
	  		}
	  		this.$refs.Header.headerTrue = false;
	  	}else{
	  		this.$refs.Header.headerTrue = true;
	  		this.$refs.Header.headerHover = true;
	  	}
		this.getBannerList(4);
		this.getList();
	  },
	  beforeDestroy() {
	  	window.removeEventListener('scroll', this.handleScroll);
	  	
	  },
	  methods: {
	  	onRouteChange(newRoute, oldRoute) {
	  	  this.currentRoute = newRoute.path; // 更新当前路由地址
	  	  this.$refs.innovationCen[0].querValue = this.$route.query.value;
	  	  // this.goScroll(this.$route.query.value)
	  	},
	  	handleScroll() {
	  		const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
	  			.scrollTop || 0;
	  		if (currentScrollTop > this.lastScrollTop) {
	  			this.navHidden = true;
	  		} else {
	  			this.navHidden = false;
	  		}
	  		this.lastScrollTop = currentScrollTop;

	  		this.$refs.innovationCen[0].navHidden = this.navHidden;
	  		if(currentScrollTop==0){
	  			if(!this.$refs.Header.navHead){
	  				this.$refs.Header.headerHover = false;
	  			}else{
					this.$refs.Header.mouseoverLi(4);
				}
	  			this.$refs.Header.headerTrue = false;
	  		}else{
	  			this.$refs.Header.headerTrue = true;
	  			this.$refs.Header.headerHover = true;
	  		}
	  	},
	  	goScroll(e){
			console.log(e,"跳转")
	  		this.lastScrollTop=e;
			var element;
			if(this.nowVibe=='pc'){
				element= document.documentElement
			}else{
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
				element.scrollTop =e+10;
	  		// document.documentElement.scrollTop = e+10;
	  	},
		// 获取列表
		getList(){
			let t = this;
			let data={}
			get_list(data).then(res=>{
				console.log(res)
				this.$nextTick(function() {
					t.$refs['innovationCen'][0].setList(res.data.list);
				})
			}).catch(err=>{
				console.log(err)
			})
		},
		// 获取轮播图
		getBannerList(e) {
			let t = this;
			let data = {
				module: e
			}
		
			get_banner(data).then((res) => {
				console.log(res)
				this.$nextTick(function() {
					t.$refs['innovationBanner'][0].setList(res.data);
				})
			}).catch((err) => {
				console.log(err)
			})
		},
	  },
	}
</script>

<style>
	
</style>
<style scoped lang="scss">
.pageBox{
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	.pageBox_cen{
		flex: 1;
	}
}
</style>